import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getAdvertisementDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  campaign: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 500,
        height: 500,
      },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_common_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_common_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Start Date",
      fieldValue: "field_start_date",
      className: "col-span-6",
      type: "dateTime",
      name: "field_start_date",
      formType: "dateTime",
      label: "Start Date",
      placeholder: "Enter Start Date",
      disabledPreviousDateTime: true,
      // validation: { required: "Start Date is required" },
    },
    {
      fieldName: "End Date",
      fieldValue: "field_end_date",
      className: "col-span-6",
      type: "dateTime",
      name: "field_end_date",
      formType: "dateTime",
      label: "End Date",
      placeholder: "Enter End Date",
      disabledPreviousDateTime: true,
      // validation: { required: "End Date is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_common_malay_description",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_description",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_common_mandarin_descriptio",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_descriptio",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Terms & Conditions (EN)",
      fieldValue: "field_terms_and_conditions",
      className: "col-span-6",
      type: "text",
      name: "field_terms_and_conditions",
      formType: "richText",
      label: "Terms & Conditions (EN)",
      placeholder: "Enter Terms & Conditions (EN)",
      // validation: { required: "Terms & Conditions (EN) is required" },
    },
    {
      fieldName: "Terms & Conditions (MS)",
      fieldValue: "field_malay_terms_and_conditions",
      className: "col-span-6",
      type: "text",
      name: "field_malay_terms_and_conditions",
      formType: "richText",
      label: "Terms & Conditions (MS)",
      placeholder: "Enter Terms & Conditions (MS)",
      //   validation: { required: "Terms & Conditions (MS) is required" },
    },
    {
      fieldName: "Terms & Conditions (ZH)",
      fieldValue: "field_mandarin_terms_and_conditi",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_terms_and_conditi",
      formType: "richText",
      label: "Terms & Conditions (ZH)",
      placeholder: "Enter Terms & Conditions (ZH)",
      //   validation: { required: "Terms & Conditions (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  // adsBanner: [
  //   {
  //     fieldName: "Images",
  //     fieldValue: "field_common_image",
  //     className: "col-span-6",
  //     type: "image",
  //     name: "field_common_image",
  //     formType: "multiFile",
  //     label: "Images",
  //     usedFileType: 'image/*',
  //     placeholder: "Select Image",
  //     validation: { required: "Image is required" },
  //   },
  //   {
  //     fieldName: "Title",
  //     fieldValue: "title",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "title",
  //     formType: "input",
  //     label: "Title",
  //     placeholder: "Enter Title",
  //     validation: { required: "Title is required" },
  //   },
  //   {
  //     fieldName: "Airports",
  //     fieldValue: "field_airport",
  //     className: "col-span-6",
  //     type: "select",
  //     name: "field_airport",
  //     formType: "multiSelect",
  //     options:[
  //       {
  //         label: "KLIA Terminal 1",
  //         value: "klia1"
  //       },
  //       {
  //         label: "KLIA Terminal 2",
  //         value: "klia2"
  //       },
  //       {
  //         label: "Penang",
  //         value: "penang"
  //       },
  //       {
  //         label: "Kuching",
  //         value: "kuching"
  //       },
  //       {
  //         label: "Langkawi",
  //         value: "langkawi"
  //       },
  //       {
  //         label: "Kota Kinabalu",
  //         value: "kota-kinabalu"
  //       },
  //     ],
  //     label: "Airports",
  //     placeholder: "Enter Airports",
  //     validation: { required: "Airports is required" },
  //   },
  // ],
  homePageCarousel: [
    {
      fieldName: "Image",
      fieldValue: "images",
      className: "col-span-6",
      type: "image",
      name: "images",
      formType: "file",
      label: "Image",
      usedFileType: "image/*",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 1920,
        height: 740,
      },
    },
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Start Date",
      fieldValue: "start_date",
      className: "col-span-6",
      type: "dateTime",
      name: "start_date",
      formType: "dateTime",
      label: "Start Date",
      placeholder: "Enter Start Date",
      disabledPreviousDateTime: true,
      // validation: { required: "Start Date is required" },
    },
    {
      fieldName: "End Date",
      fieldValue: "end_date",
      className: "col-span-6",
      type: "dateTime",
      name: "end_date",
      formType: "dateTime",
      label: "End Date",
      placeholder: "Enter End Date",
      disabledPreviousDateTime: true,
      // validation: { required: "End Date is required" },
    },
    // {
    //   fieldName: "Airports",
    //   fieldValue: "field_airport",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "field_airport",
    //   formType: "multiSelect",
    //   options: [
    //     {
    //       label: "KLIA Terminal 1",
    //       value: "klia1",
    //     },
    //     {
    //       label: "KLIA Terminal 2",
    //       value: "klia2",
    //     },
    //     {
    //       label: "Penang",
    //       value: "penang",
    //     },
    //     {
    //       label: "Kuching",
    //       value: "kuching",
    //     },
    //     {
    //       label: "Langkawi",
    //       value: "langkawi",
    //     },
    //     {
    //       label: "Kota Kinabalu",
    //       value: "kota-kinabalu",
    //     },
    //   ],
    //   label: "Airports",
    //   placeholder: "Enter Airports",
    //   validation: { required: "Airports is required" },
    // },
    {
      fieldName: "Published",
      fieldValue: "status",
      className: "col-span-12",
      type: "checkbox",
      name: "status",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  bannerPromotion: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      label: "Image",
      usedFileType: "image/*",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 1920,
        height: 740,
      },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "field_english_title",
      className: "col-span-6",
      type: "text",
      name: "field_english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
  ],
  bannerTopSelling: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      label: "Image",
      usedFileType: "image/*",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 1920,
        height: 740,
      },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "field_english_title",
      className: "col-span-6",
      type: "text",
      name: "field_english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
  ],
  bannnerBrands: [
    {
      fieldName: "Beauty Image",
      fieldValue: "field_beauty_image",
      className: "col-span-6",
      type: "image",
      name: "field_beauty_image",
      formType: "file",
      label: "Image 1",
      usedFileType: "image/*",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 1920,
        height: 740,
      },
    },
    {
      fieldName: "Confectionary Image",
      fieldValue: "field_confectionary_image",
      className: "col-span-6",
      type: "image",
      name: "field_confectionary_image",
      formType: "file",
      label: "Image 2",
      usedFileType: "image/*",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 1920,
        height: 740,
      },
    },
    {
      fieldName: "Wine & Spirits Image",
      fieldValue: "field_wine_spirits_image",
      className: "col-span-6",
      type: "image",
      name: "field_wine_spirits_image",
      formType: "file",
      label: "Image 3",
      usedFileType: "image/*",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 1920,
        height: 740,
      },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "field_english_title",
      className: "col-span-6",
      type: "text",
      name: "field_english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
  ],
  bannerNews: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_english_title",
      className: "col-span-6",
      type: "text",
      name: "field_english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
  ],
};
